var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefillEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.1875C11.9584 10.1875 8.93379 12.3904 7.70837 15.5C8.93379 18.6096 11.9584 20.8125 15.5 20.8125C19.0417 20.8125 22.0663 18.6096 23.2917 15.5C22.0663 12.3904 19.0417 10.1875 15.5 10.1875ZM15.5 19.0417C13.545 19.0417 11.9584 17.455 11.9584 15.5C11.9584 13.545 13.545 11.9583 15.5 11.9583C17.455 11.9583 19.0417 13.545 19.0417 15.5C19.0417 17.455 17.455 19.0417 15.5 19.0417ZM15.5 13.375C14.3242 13.375 13.375 14.3242 13.375 15.5C13.375 16.6758 14.3242 17.625 15.5 17.625C16.6759 17.625 17.625 16.6758 17.625 15.5C17.625 14.3242 16.6759 13.375 15.5 13.375Z",
    fill: "#7D7D7D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15,
    stroke: "#4C4C4C",
    strokeOpacity: 0.09
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefillEye);
export default __webpack_public_path__ + "static/media/refillEye.7077cf35918a9c5fd70a8587df02d62d.svg";
export { ForwardRef as ReactComponent };